import React, { useState } from "react";
import { Link } from "react-scroll";
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div className="top-0 z-50 absolute w-[80%] max-w-[1370px] flex flex-row mt-[50px] justify-between items-center">
      <h1 className="text-xl md:text-4xl text-customGreen font-semibold text-center">Valerio Pescetelli</h1>
      <nav className="hidden md:flex justify-center text-white font-bold transition">
        <Link
          className="p-4 hover:text-customGreen transition cursor-pointer"
          to="biography"
          spy={true}
          smooth={true}
          duration={500}
        >
          Biography
        </Link>
        <Link
          className="p-4 hover:text-customGreen transition cursor-pointer"
          to="careers"
          spy={true}
          smooth={true}
          duration={500}
        >
          Careers
        </Link>
        <Link
          className="p-4 hover:text-customGreen transition cursor-pointer"
          to="expertise"
          spy={true}
          smooth={true}
          duration={500}
        >
          Expertise
        </Link>
        <Link
          className="p-4 hover:text-customGreen transition cursor-pointer"
          to="contact"
          spy={true}
          smooth={true}
          duration={500}
        >
          Contact
        </Link>
      </nav>
      <div className="md:hidden flex items-center">
        <button onClick={toggleMenu} className="text-white z-50 relative">
          {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>
      </div>
      {menuOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex flex-col justify-center items-center z-40">
          <Link
            className="p-4 text-2xl text-white hover:text-customGreen transition cursor-pointer"
            to="biography"
            spy={true}
            smooth={true}
            duration={500}
            onClick={toggleMenu}
          >
            Biography
          </Link>
          <Link
            className="p-4 text-2xl text-white hover:text-customGreen transition cursor-pointer"
            to="careers"
            spy={true}
            smooth={true}
            duration={500}
            onClick={toggleMenu}
          >
            Careers
          </Link>
          <Link
            className="p-4 text-2xl text-white hover:text-customGreen transition cursor-pointer"
            to="expertise"
            spy={true}
            smooth={true}
            duration={500}
            onClick={toggleMenu}
          >
            Expertise
          </Link>
          <Link
            className="p-4 text-2xl text-white hover:text-customGreen transition cursor-pointer"
            to="contact"
            spy={true}
            smooth={true}
            duration={500}
            onClick={toggleMenu}
          >
            Contact
          </Link>
        </div>
      )}
    </div>
  );
};

export default Navbar;
